/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIOrgUser } from './APIOrgUser';
import {
    APIOrgUserFromJSON,
    APIOrgUserFromJSONTyped,
    APIOrgUserToJSON,
} from './APIOrgUser';

/**
 * 
 * @export
 * @interface APIPaginatedOrgUserList
 */
export interface APIPaginatedOrgUserList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedOrgUserList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedOrgUserList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedOrgUserList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIOrgUser>}
     * @memberof APIPaginatedOrgUserList
     */
    results: Array<APIOrgUser>;
}

/**
 * Check if a given object implements the APIPaginatedOrgUserList interface.
 */
export function instanceOfAPIPaginatedOrgUserList(value: object): value is APIPaginatedOrgUserList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedOrgUserListFromJSON(json: any): APIPaginatedOrgUserList {
    return APIPaginatedOrgUserListFromJSONTyped(json, false);
}

export function APIPaginatedOrgUserListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedOrgUserList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIOrgUserFromJSON)),
    };
}

export function APIPaginatedOrgUserListToJSON(value?: APIPaginatedOrgUserList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIOrgUserToJSON)),
    };
}

